import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-align-center-icon',
  templateUrl: './text-align-center.component.html'
})
export class TextAlignCenterComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
